import gql from 'graphql-tag';

export const countryFragments = gql`
  fragment countryFragments on Country {
    code
    name
    phoneCode
  }
`;

export const ALL_COUNTRIES = gql`
  query allCountries {
    allCountries {
      ...countryFragments
    }
  },
  ${countryFragments}
`;
